import { useQuery } from '@tanstack/react-query';
import { tenderRequirementsApi } from '../../../api/tenderRequirements';

// Hook to get tender document requirements for vendors
export function useVendorTenderRequirements(tenderId: string) {
  return useQuery({
    queryKey: ['vendor-tender-requirements', tenderId],
    queryFn: () => tenderRequirementsApi.listVendorRequirements(tenderId),
    enabled: !!tenderId,
    staleTime: 5 * 60 * 1000, // Consider data fresh for 5 minutes
    refetchOnWindowFocus: false, // Don't refetch on window focus
    refetchOnMount: false, // Don't refetch on component mount if data exists
  });
}

